<template>
    <svg viewBox="0 0 64 64" class="pie" :style="{background: `${colors.report.pie}71`}">
        <circle r="25%" cx="50%" cy="50%" :stroke-dasharray="strokeValue" :style="{stroke: `${colors.report.pie}`}"></circle>
    </svg>
</template>

<script>
export default {
    name: 'pie-chart',
    props:['color', 'strokeValue'],
    data: () =>({
        colors: {}
    }),
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    }
}
</script>

<style lang="scss">
.strokePurple{
    background-color: #470349 !important;

    circle{
        stroke: #83037D;
    }
}

// .strokeGray{
//     background-color: rgba($color: #2F353A, $alpha: .25)!important;

//     circle{
//         stroke:  rgba($color: #2F353A, $alpha: .20);
//     }
// }

.pie {
    width: 98px;
    background: 12px 4px;
    border-radius: 50%;
    margin: 22px 7px;
    transform: rotate(-90deg);
}

.pie circle {
    fill: none;
    stroke-width: 32;
    animation: rotate 1.5s ease-in;
}

// @keyframes rotate {
//   to {
//     x
//   } 
// }
</style>
